<template>
    <v-container>
        <v-card v-if="permisoConfFalloCiclo">
            <v-card-title class="primary">Configuracion para fallo en ciclo</v-card-title>
            <config-higienizacion @cambio="cambio" idHigienizacion="1"></config-higienizacion>
            <config-higienizacion @cambio="cambio" idHigienizacion="2"></config-higienizacion>
        </v-card>
        <v-card v-else disabled>
            <v-card-title class="primary">Configuracion para fallo en ciclo</v-card-title>
            <config-higienizacion idHigienizacion="1"></config-higienizacion>
            <config-higienizacion idHigienizacion="2"></config-higienizacion>
        </v-card>
    </v-container>
</template>

<script>
import configHigienizacion from '@/components/configHigienizacion.vue';
import {mapActions, mapState } from 'vuex'

export default {
    name: "Configuracion",
    components: {
        configHigienizacion
    },
    data() {
        return {
            permisoConfFalloCiclo: false,
            datos_configuracion:{
                'hig1_tiempo_seg':null,
                'hig1_temperatura':null,
                'hig2_tiempo_seg':null,
                'hig2_temperatura':null,
            }
        }
    },
    computed: {
        ...mapState("eggnovo",[
            'higienizacion1',
            'higienizacion2',
        ]),
    },
    methods: {
        ...mapActions("eggnovo",[
            'set_temp_umbral_hig1',
            'set_temp_umbral_hig2',
            'set_tiempo_umbral_hig1',
            'set_tiempo_umbral_hig2'
        ]),
        ...mapActions(["getData"]),
        segundosAMinutos(segundos){
            return Math.round(segundos/60) //Redondeo a minutos exactos
        },
        permisosUsuario(){
            if(localStorage.getItem('id_rol') != 2){ // Todos menos rol básico 
                this.permisoConfFalloCiclo = true
                this.headers = [
                    {text:"USUARIO", align:"center", value:"name"},
                    {text:"PERMISO", align:"center", value:"rol"},
                    {text:"OPCIONES", align:"center", sortable: false, value:"actions"},
                ]
            }else{
                this.permisoConfFalloCiclo = false
            }
        },
        async getParametrosConfiguracion(){
            // const res = await this.axios.get('/configuracion')
            const payload = {
                path: 'configuracion/configuracion',
            }

            const res = await this.getData(payload)
            // console.log("getParametrosConfiguracion")
            const {id,hig1_tiempo_seg,hig1_temperatura,hig2_tiempo_seg,hig2_temperatura}=res.results[0]
            this.set_temp_umbral_hig1(hig1_temperatura)
            this.set_temp_umbral_hig2(hig2_temperatura)
            this.set_tiempo_umbral_hig1(hig1_tiempo_seg)
            this.set_tiempo_umbral_hig2(hig2_tiempo_seg)
        },
        async cambio(){
            //obtener los cambios
            // this.getParametrosConfiguracion();
            this.higienizacion1.temperaturaUmbral

            const parametros = {
                hig1_tiempo_seg:this.higienizacion1.tiempoUmbral,
                hig1_temperatura:this.higienizacion1.temperaturaUmbral,
                hig2_tiempo_seg:this.higienizacion2.tiempoUmbral,
                hig2_temperatura:this.higienizacion2.temperaturaUmbral,
            }
            console.log(parametros)
            //guardar parametros en bbdd
            // const res = await this.axios.post('/nueva-configuracion',parametros)
            const payload = {
                path: 'configuracion/nueva-configuracion',
                body: parametros,
            }
            const res = await this.postData(payload);
            this.getParametrosConfiguracion();
        }
    },
    created() {
        this.permisosUsuario()
    },
    mounted() {
        this.getParametrosConfiguracion();
    },
}
</script>

<style>
</style>